import StatusChangedMsg from '@apptypes/WebsocketUserStatus.ts';
import { CustomWindowEvents } from '@constants';
import { useAuth } from '@hooks/useAuth.tsx';
import { setBalance } from '@state/reducers/user.ts';
import { injectTrackerScript } from '@utils/uiUtils.ts';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSocket } from '../../containers/websocket-provider.tsx';

export function WebSocketPlayerBalanceChangedWatcher() {
  const { getLatest } = useSocket();
  const { user, updateUser } = useAuth();
  const dispatch = useDispatch();

  const balanceChanged: StatusChangedMsg | undefined =
    getLatest('balance_changed');

  const lastProcessedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!balanceChanged) return;

    // @ts-ignore
    const data = balanceChanged.data;
    const key = JSON.stringify([
      //@ts-ignore
      balanceChanged.action,
      data?.player_id,
      data?.balance_after,
      data?.amount,
      data?.balance_type,
    ]);

    if (lastProcessedRef.current === key) return;
    lastProcessedRef.current = key;

    updateUser(true);

    if (data) {
      if (data.balance_type?.includes('Kambi')) {
        injectTrackerScript('betconfirm', user.id, user.currency, data.amount);
      }
      window.dispatchEvent(new Event(CustomWindowEvents.ResetIdleTimer));
      dispatch(setBalance(data.balance_after));
    }
  }, [balanceChanged, dispatch, updateUser, user.id, user.currency]);

  return null;
}
